export const NOTES = {
  refund_note:
    "If any payout for a booking is pending and a refund is initiated against the booking, then the payout will automatically be cancelled.",
  partial_refund_note:
    "If any payout for a booking is pending and a refund is initiated against the booking, then the payout will automatically be recalculated.",
};
